export default "__VITE_ASSET__YAfJr2_S__"